export class Acceso {
    constructor(public tipo: string, public id_sistema: number,  public id_acceso: number, public nom_acceso: string, public path_acceso: string, public icono_acceso: string, public nombre_usuario: string) {}
} 